module.exports = __webpack_public_path__ + "static/media/centuryGothic-Bold.7bea0c92.ttf";